import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { QualityControlPainting, RepositoryModal } from '../../../shared'
import { PaintingComponent } from './painting.component'

@Component({
    templateUrl: './painting-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class PaintingModalComponent extends RepositoryModal<QualityControlPainting> implements OnInit {
    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as PaintingComponent

        if (this.isAdding) {
            this.target.job = parentComponent.selectedJob()
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) {
            this.services.notification.warning('Job is required')
            return false
        }
        return true
    }
}
